import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { createId } from '@core/util/file';
import { MatterAffidavit } from '@models/matter';
import { AffidavitDispatch } from '@state/matter/affidavit';
import { cloneDeep } from 'lodash';
import { ICON } from '@core/util/icon';
import { TestHooks } from './custom-statement.hooks';

@Component({
	selector: 'app-custom-statement',
	templateUrl: 'custom-statement.component.html',
	standalone: false,
})
export class CustomStatementComponent {
	testHooks = TestHooks;
	public affidavit: MatterAffidavit;
	public busy: boolean;
	public ICON = ICON;

	constructor(
		private affidavitDispatch: AffidavitDispatch,
		@Inject(MAT_DIALOG_DATA)
		public data: { affidavit: MatterAffidavit; clientId: string },
		public dialogRef: MatDialogRef<CustomStatementComponent>,
	) {
		this.busy = false;
		this.affidavit = cloneDeep(this.data.affidavit);
	}

	cancel(): void {
		this.dialogRef.close();
	}

	changed(): void {}

	save(): void {
		if (!this.busy) {
			this.busy = true;
			const affidavitId = this.affidavit.id || createId();

			this.affidavitDispatch.Create({
				...this.affidavit,
				id: affidavitId,
			});
			this.dialogRef.close();
		}
	}
}
